import { render, staticRenderFns } from "./212.vue?vue&type=template&id=05cb4cbf&scoped=true&"
var script = {}
import style0 from "./212.vue?vue&type=style&index=0&id=05cb4cbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cb4cbf",
  null
  
)

export default component.exports